import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ModeControlData {
  ref: number;
  label: string;
  icon: string;
  color: string;
  onPress?: (vale: any) => void;
}

@Component({
  selector: 'app-mode-control-multiple',
  templateUrl: './mode-control-multiple.component.html',
  styleUrls: ['./mode-control-multiple.component.scss'],
})
export class ModeControlMultipleComponent {
  @Input() datas: ModeControlData[] = [];
  @Input() value: number = 0;

  //eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onChange = new EventEmitter<number>();

  onButtonClick(data: ModeControlData): void {
    if (data.onPress) {
      data.onPress(data.ref);
    } else {
      this.onChange.emit(data.ref);
    }
  }
}
